import React from 'react'
import PropTypes from 'prop-types'

import '../styles/loginInfo.scss'

const LoginInfo = ({ termsLink, policyLink }) => (
  <p className='LoginInfo'>By registering, I agree to the&nbsp;
    <a target='_blank' rel='noopener noreferrer' href={termsLink}>Terms of Service</a> and the&nbsp;
    <a target='_blank' rel='noopener noreferrer' href={policyLink}>Privacy Policy.</a>
  </p>
)

LoginInfo.propTypes = {
  termsLink: PropTypes.string.isRequired,
  policyLink: PropTypes.string.isRequired,
}

export default LoginInfo
